import L from 'leaflet';
import IconImage from '../../assets/Images/map-marker.png';

const iconPerson = new L.Icon({
    iconUrl: IconImage,
    iconRetinaUrl: IconImage,
    iconSize: new L.Point(40, 45),
});

export default iconPerson;
